import { gql } from "@apollo/client";

export const GET_COMPANY_EQUIPMENTS = gql`
  query Export_companyEquipments($idmUserUuid: String!, $companyUuid: String!) {
    export_companyEquipments(
      idmUserUUID: $idmUserUuid
      companyUUID: $companyUuid
    ) {
      ID
      name
    }
  }
`;

export const ORDERS_SEARCH = gql`
  query Export_ordersSearch(
    $orderNumber: String
    $regNum: String
    $code: String
    $companyUuid: String
  ) {
    export_ordersSearch(
      orderNumber: $orderNumber
      regNum: $regNum
      code: $code
      companyUUID: $companyUuid
    ) {
      user {
        id
        name {
          firstName
          middleName
          lastName
          fullName
        }
        birthday
        email
        phone
        telegram
        employee
        imageUrls
        sex
      }
      orderID
      department {
        ID
        name
        workTime
        adress
        locationLatitude
        locationLongitude
        phone
        region
        imageList
        imageUrls
      }
      car {
        id
        color
        marka {
          id
          name
          imageUrl
        }
        model {
          id
          name
          imageUrl
        }
        vin
        year
      }
      docDate
      docNumber
      currencyName
      docSum {
        operations
        parts
        total
      }
      masterName
      mileage
      operations {
        count
        discount
        name
        sum
      }
      parts {
        count
        discount
        name
        sum
      }
      payPaid
      payWaiting
      payDebt
      status
      payStatus
      type
      planDate
      description
      userCredits
    }
  }
`;

export const EXPORT_ORDER_READ = gql`
  query OrderRead($orderId: String!, $userID: String, $companyUUID: String) {
    export_orderRead(
      orderID: $orderId
      userID: $userID
      companyUUID: $companyUUID
    ) {
      userID
      carID
      departmentID
      description
      docDate
      docNumber
      currencyName
      docSum {
        operations
        parts
        total
      }
      masterName
      mileage
      operations {
        count
        discount
        name
        sum
      }
      orderID
      parts {
        count
        discount
        name
        sum
      }
      status
      type
      planDate
      payPaid
      payWaiting
      payDebt
      payStatus
      payCredits
    }
  }
`;
export const EXPORT_PAYMENT_CHECK = gql`
  query Export_paymentCheck(
    $paymentId: String!
    $orderId: String
    $userId: String
    $companyUuid: String
  ) {
    export_paymentCheck(
      paymentID: $paymentId
      orderID: $orderId
      userID: $userId
      companyUUID: $companyUuid
    ) {
      code
      message
    }
  }
`;

export const EXPORT_PAYMENT_CREATE = gql`
  mutation Export_paymentCreate(
    $companyUuid: String!
    $orderId: String!
    $credits: Float
  ) {
    export_paymentCreate(
      companyUUID: $companyUuid
      orderID: $orderId
      credits: $credits
    ) {
      code
      success
      message
      result {
        paymentID
        paymentUrl
        paymentSum
      }
    }
  }
`;

export const EXPORT_ORDER_CREDIT = gql`
  query Export_creditOrder(
    $orderId: String!
    $userId: String
    $companyUuid: String
  ) {
    export_creditOrder(
      orderID: $orderId
      userID: $userId
      companyUUID: $companyUuid
    ) {
      orderID
      credits
    }
  }
`;

export const EXPORT_ORDERS_LIST = gql`
  query Export_ordersList($companyUuid: String) {
    export_ordersList(companyUUID: $companyUuid) {
      userID
      carID
      departmentID
      description
      docDate
      docNumber
      currencyName
      docSum {
        operations
        parts
        total
      }
      masterName
      mileage
      operations {
        count
        discount
        name
        sum
      }
      orderID
      parts {
        count
        discount
        name
        sum
      }
      status
      type
      planDate
      payPaid
      payWaiting
      payDebt
      payStatus
      payCredits
    }
  }
`;

export const EXPORT_GET_CREDITS = gql`
  query Export_creditBalance($userId: String, $companyUuid: String) {
    export_creditBalance(userID: $userId, companyUUID: $companyUuid) {
      activeCreditsTotal
    }
  }
`;
